if(!customElements.get("article-navigation")) {
  customElements.define("article-navigation", class ArticleNavigation extends HTMLElement {
    constructor() {
      super();

      this.blogData = JSON.parse(this.querySelector("#blogData").textContent);
      this.mobileTitle = this.querySelector(".blogArchive.blog-mobile");
      this.navContainer = this.querySelector(".BlogGrid__nav");

      this.navInit();
    }

    navInit() {
      if(this.mobileTitle) this.mobileTitle.addEventListener("click", this.titleClick.bind(this));

      const blogs = this.blogData.blogs;
      const sortedYears = [];
      const monthCategory = [];

      blogs.forEach((blog) => {
        sortedYears.indexOf(blog.year) === -1 ? sortedYears.push(blog.year) : "";
      });

      sortedYears.forEach((year) => {
        monthCategory.push({
          year,
          January: [],
          February: [],
          March: [],
          April: [],
          May: [],
          June: [],
          July: [],
          August: [],
          September: [],
          October: [],
          November: [],
          December: []
        });
      });

      blogs.forEach(blog => {
        const articleYear = blog.year;
        const articleMonth = blog.month;
        const articleTitle = blog.title;
        const articleLink = blog.url;

        monthCategory.forEach(category => {
          if (category.year === articleYear) {
             switch (articleMonth) {
               case '01':
                 category.January.push({title: articleTitle, url: articleLink });
                 break;
               case '02':
                 category.February.push({title: articleTitle, url: articleLink });
                 break;
               case '03':
                 category.March.push({title: articleTitle, url: articleLink });
                 break;
               case '04':
                 category.April.push({title: articleTitle, url: articleLink });
                 break;
               case '05':
                 category.May.push({title: articleTitle, url: articleLink });
                 break;
               case '06':
                 category.June.push({title: articleTitle, url: articleLink });
                 break;
               case '07':
                 category.July.push({title: articleTitle, url: articleLink });
                 break;
               case '08':
                 category.August.push({title: articleTitle, url: articleLink });
                 break;
               case '09':
                 category.September.push({title: articleTitle, url: articleLink });
                 break;
               case '10':
                 category.October.push({title: articleTitle, url: articleLink });
                 break;
               case '11':
                 category.November.push({title: articleTitle, url: articleLink });
                 break;
               case '12':
                 category.December.push({title: articleTitle, url: articleLink });
                 break;
            }
          }
        });
      });

      // render the sorted data to screen
      this.renderNavigation(monthCategory);
    }

    renderNavigation(monthCategory) {
      const navigationHTML = monthCategory.map((category) => {
        return `
          <div class="BlogGrid__navYear">
            <h5>${category.year}</h5>
            <ul id="${category.year}">
              ${Object.keys(category).map(key => {
                return category[key].length > 0 && key !== "year" ?
                  `<li class="BlogGrid__navMonth">
                    <p>${key} (${category[key].length})</p>
                    <ul id="BlogGrid__articles${key}${category[key].year}">
                      ${category[key].map(article => {
                        return `
                          <li>
                            <p><a href="${article.url}">${article.title}</a></p>
                          </li>
                        `
                      }).join("")}
                    </ul>
                  </li>` : ""
              }).join("")}
            </ul>
          </div>
        `;
      }).join("");

      this.navContainer.innerHTML = navigationHTML;
    }

    titleClick() {
      this.mobileTitle.classList.toggle("navopen");
    }
  });
}
